import { render, staticRenderFns } from "./OpeningHours.vue?vue&type=template&id=666d5c6e&scoped=true&"
import script from "./OpeningHours.vue?vue&type=script&lang=ts&"
export * from "./OpeningHours.vue?vue&type=script&lang=ts&"
import style0 from "./OpeningHours.vue?vue&type=style&index=0&id=666d5c6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666d5c6e",
  null
  
)

export default component.exports